import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const speciesStartRequest = () => {
  return {
    type: 'SPECIES_START_REQUEST'
  };
};

export const speciesEndRequest = () => {
  return {
    type: 'SPECIES_END_REQUEST'
  };
};

export const getAllSpeciesSuccess = ({ data }) => {
  return {
    type: 'SPECIES_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllSpeciesError = error => {
  return {
    type: 'SPECIES_GET_ALL_ERROR',
    payload: error
  };
};

export const addSpeciesSuccess = ({ data }) => {
  return {
    type: 'SPECIES_ADD_SUCCESS',
    payload: data
  };
};

export const addSpeciesError = error => {
  return {
    type: 'SPECIES_ADD_ERROR',
    payload: error
  };
};

export const editSpeciesSuccess = ({ data }) => {
  return {
    type: 'SPECIES_EDIT_SUCCESS',
    payload: data
  };
};

export const editSpeciesError = error => {
  return {
    type: 'SPECIES_EDIT_ERROR',
    payload: error
  };
};

export const removeSpeciesSuccess = id => {
  return {
    type: 'SPECIES_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeSpeciesError = error => {
  return {
    type: 'SPECIES_REMOVE_ERROR',
    payload: error
  };
};

export const speciesModifyStore = ({ data }) => {
  return {
    type: 'SPECIES_MODIFY_STORE',
    payload: data
  };
};

export const addSpecies = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(speciesStartRequest());
      const response = await api().post('/api/species', data);
      dispatch(addSpeciesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'species',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addSpeciesError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(speciesEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllSpecies = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(speciesStartRequest());
      const response = await api().get('/api/species', { params });
      dispatch(getAllSpeciesSuccess(response));
    } catch (err) {
      dispatch(getAllSpeciesError(err));
    } finally {
      dispatch(speciesEndRequest());
    }
  };
};

export const editSpecies = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(speciesEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(speciesStartRequest());
      const id = data._id;
      const response = await api().put('/api/species/' + id, data);
      dispatch(editSpeciesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'species',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/species'));
      }
    } catch (err) {
      dispatch(editSpeciesError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeSpecies = id => {
  return async dispatch => {
    try {
      dispatch(speciesStartRequest());
      await api().delete('/api/species/' + id);
      dispatch(removeSpeciesSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'species',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Espécie removida com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeSpeciesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover espécie.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(speciesEndRequest());
    }
  };
};

export const restoreSpecies = data => {
  return async dispatch => {
    try {
      dispatch(speciesStartRequest());
      const id = data._id;
      const response = await api().put('/api/species/' + id, data);
      dispatch(editSpeciesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'species',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Espécie restaurada com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editSpeciesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar espécie.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(speciesEndRequest());
    }
  };
};
